export enum RugbyUnionIncidentId {
  NotStarted = 701,
  Interrupted = 702,
  Cancelled = 703,
  Postponed = 705,
  StartDelayed = 706,
  Abandoned = 707,
  FirstHalf = 708,
  Halftime = 709,
  SecondHalf = 710,
  FinishedRegularTime = 711,
  FinishedAwardedWin = 712,
  FinishedAfterExtratime = 714,
  Extratime = 715,
  ToFinish = 717,
  InPossession = 1068,
  EntryInto22 = 1069,
  Kick = 1070,
  GoallineDropout = 1071,
  Offload = 1072,
  Turnover = 1073,
  Ruck = 1074,
  Maul = 1075,
  Scrum = 1076,
  Lineout = 1077,
  Injury = 1078,
  Tackle = 1079,
  Timeout = 1080,
  Kickoff = 1081,
  MedicalTimeout = 1082,
  RefereeReview = 1083,
  BreakDuringGame = 1084,
  ExtratimeFirstHalf = 1085,
  ExtratimeHalftime = 1086,
  ExtratimeSecondHalf = 1087,
  PenaltiesStarted = 1088,
  Foul = 1089,
  WaterBreak = 1090,
  Try = 2946,
  PenaltyTry = 2947,
  ConversionGoal = 2948,
  ConversionMissed = 2949,
  ConversionAttempt = 2950,
  PenaltyKickGoal = 2951,
  PenaltyKickMissed = 2952,
  PenaltyAwarded = 2953,
  DropGoal = 2954,
  DropGoalMissed = 2955,
  YellowCard = 2956,
  RedCard = 2957,
  SubstitutionIn = 2958,
  OrangeCard = 2959,
  SubstitutionOut = 2985,
  WaitingForExtratime = 2986,
  WaitingForPenalty = 2987,
  FreeKick = 2988,
  FinishedAfterPenalties = 3005,
  MatchAboutToStart = 3043,
  // Custom incident ID for Cards, as there is no single card incident on API side, but we want to display "Cards" button on UI instead of separate "Yellow card", "Red card" and "Orange card" buttons.
  Cards = 99999,
}
